import { BpmnCellHelper } from "@edp-pmf/grapheditor";
import { AifCreationBillActivityCell } from "./AifCreationBillActivityCell";
import { AutoActivityCell } from "./AutoActivityCell";
import { CallActivitySubProcessCell } from "./CallActivitySubProcessCell";
import { IntermediateCatchEventImplCell } from "./IntermediateCatchEventImplCell";
import { MessageActivityCell } from "./MessageActivityCell";
import { NotifyActivityCell } from "./NotifyActivityCell";
import { OperationActivityCell } from "./OperationActivityCell";
import { StartActivityCell } from "./StartActivityCell";
import { UserActivityCell } from "./UserActivityCell";
import { WfEndEventCell } from "./WfEndEventCell";
import { WfExclusiveGatewayCell } from "./WfExclusiveGatewayCell";
import { WfParallelGatewayCell } from "./WfParallelGatewayCell";
import { WfSequenceFlowEdge } from "./WfSequenceFlowEdge";
import { WfInclusiveGatewayCell } from "./WfInclusiveGatewayCell";

BpmnCellHelper.register(AifCreationBillActivityCell.CLR_TYPE_ID, AifCreationBillActivityCell);
BpmnCellHelper.register(AutoActivityCell.CLR_TYPE_ID, AutoActivityCell);
BpmnCellHelper.register(CallActivitySubProcessCell.CLR_TYPE_ID, CallActivitySubProcessCell);
BpmnCellHelper.register(IntermediateCatchEventImplCell.CLR_TYPE_ID, IntermediateCatchEventImplCell);
BpmnCellHelper.register(MessageActivityCell.CLR_TYPE_ID, MessageActivityCell);
BpmnCellHelper.register(NotifyActivityCell.CLR_TYPE_ID, NotifyActivityCell);
BpmnCellHelper.register(OperationActivityCell.CLR_TYPE_ID, OperationActivityCell);
BpmnCellHelper.register(StartActivityCell.CLR_TYPE_ID, StartActivityCell);
BpmnCellHelper.register(UserActivityCell.CLR_TYPE_ID, UserActivityCell);
BpmnCellHelper.register(WfEndEventCell.CLR_TYPE_ID, WfEndEventCell);
BpmnCellHelper.register(WfExclusiveGatewayCell.CLR_TYPE_ID, WfExclusiveGatewayCell);
// 暂时隐藏包容网关
BpmnCellHelper.register(WfInclusiveGatewayCell.CLR_TYPE_ID, WfInclusiveGatewayCell);
BpmnCellHelper.register(WfParallelGatewayCell.CLR_TYPE_ID, WfParallelGatewayCell);
BpmnCellHelper.register(WfSequenceFlowEdge.CLR_TYPE_ID, WfSequenceFlowEdge);
